<template>
  <span class="pp-pro-badge" :class="`pp-pro-badge--${size}`">{{ label }}</span>
</template>

<script>
// Selo PRO: mesmo roxo do "MODULO ADICIONAL" do produto (#6554C0).
export default {
  name: "ProBadge",
  props: {
    label: { type: String, default: "PRO" },
    size: { type: String, default: "sm" }, // sm | md
  },
};
</script>

<style lang="scss">
.pp-pro-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: #6554c0;
  color: #fff;
  font-family: Roboto, sans-serif;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;

  &--sm {
    height: 18px;
    padding: 0 6px;
    font-size: 10px;
  }

  &--md {
    height: 20px;
    padding: 0 8px;
    font-size: 11px;
  }
}
</style>
